/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BoothDto } from '../models/booth-dto';
import { floorPlanAdminControllerCreateBoothV1 } from '../fn/floor-plan-admin/floor-plan-admin-controller-create-booth-v-1';
import { FloorPlanAdminControllerCreateBoothV1$Params } from '../fn/floor-plan-admin/floor-plan-admin-controller-create-booth-v-1';
import { floorPlanAdminControllerCreateV1 } from '../fn/floor-plan-admin/floor-plan-admin-controller-create-v-1';
import { FloorPlanAdminControllerCreateV1$Params } from '../fn/floor-plan-admin/floor-plan-admin-controller-create-v-1';
import { floorPlanAdminControllerDeleteBoothV1 } from '../fn/floor-plan-admin/floor-plan-admin-controller-delete-booth-v-1';
import { FloorPlanAdminControllerDeleteBoothV1$Params } from '../fn/floor-plan-admin/floor-plan-admin-controller-delete-booth-v-1';
import { floorPlanAdminControllerDeleteV1 } from '../fn/floor-plan-admin/floor-plan-admin-controller-delete-v-1';
import { FloorPlanAdminControllerDeleteV1$Params } from '../fn/floor-plan-admin/floor-plan-admin-controller-delete-v-1';
import { floorPlanAdminControllerFindByIdV1 } from '../fn/floor-plan-admin/floor-plan-admin-controller-find-by-id-v-1';
import { FloorPlanAdminControllerFindByIdV1$Params } from '../fn/floor-plan-admin/floor-plan-admin-controller-find-by-id-v-1';
import { floorPlanAdminControllerSearchV1 } from '../fn/floor-plan-admin/floor-plan-admin-controller-search-v-1';
import { FloorPlanAdminControllerSearchV1$Params } from '../fn/floor-plan-admin/floor-plan-admin-controller-search-v-1';
import { floorPlanAdminControllerUpdateBoothV1 } from '../fn/floor-plan-admin/floor-plan-admin-controller-update-booth-v-1';
import { FloorPlanAdminControllerUpdateBoothV1$Params } from '../fn/floor-plan-admin/floor-plan-admin-controller-update-booth-v-1';
import { floorPlanAdminControllerUpdateV1 } from '../fn/floor-plan-admin/floor-plan-admin-controller-update-v-1';
import { FloorPlanAdminControllerUpdateV1$Params } from '../fn/floor-plan-admin/floor-plan-admin-controller-update-v-1';
import { FloorPlanDto } from '../models/floor-plan-dto';
import { PageInfoDto } from '../models/page-info-dto';

@Injectable({ providedIn: 'root' })
export class FloorPlanAdminService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `floorPlanAdminControllerSearchV1()` */
  static readonly FloorPlanAdminControllerSearchV1Path = '/api/v1/floor-plans/admin';

  /**
   * 배치도 목록 조회 (검색/페이지네이션).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `floorPlanAdminControllerSearchV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  floorPlanAdminControllerSearchV1$Response(params: FloorPlanAdminControllerSearchV1$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<FloorPlanDto>;
'pageInfo': PageInfoDto;
}>> {
    const obs = floorPlanAdminControllerSearchV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 배치도 목록 조회 (검색/페이지네이션).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `floorPlanAdminControllerSearchV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  floorPlanAdminControllerSearchV1(params: FloorPlanAdminControllerSearchV1$Params, context?: HttpContext): Observable<{
'items': Array<FloorPlanDto>;
'pageInfo': PageInfoDto;
}> {
    const resp = this.floorPlanAdminControllerSearchV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'items': Array<FloorPlanDto>;
'pageInfo': PageInfoDto;
}>): {
'items': Array<FloorPlanDto>;
'pageInfo': PageInfoDto;
} => r.body)
    );
  }

  /** Path part for operation `floorPlanAdminControllerCreateV1()` */
  static readonly FloorPlanAdminControllerCreateV1Path = '/api/v1/floor-plans/admin';

  /**
   * 배치도 생성.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `floorPlanAdminControllerCreateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  floorPlanAdminControllerCreateV1$Response(params: FloorPlanAdminControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<FloorPlanDto>> {
    const obs = floorPlanAdminControllerCreateV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 배치도 생성.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `floorPlanAdminControllerCreateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  floorPlanAdminControllerCreateV1(params: FloorPlanAdminControllerCreateV1$Params, context?: HttpContext): Observable<FloorPlanDto> {
    const resp = this.floorPlanAdminControllerCreateV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<FloorPlanDto>): FloorPlanDto => r.body)
    );
  }

  /** Path part for operation `floorPlanAdminControllerFindByIdV1()` */
  static readonly FloorPlanAdminControllerFindByIdV1Path = '/api/v1/floor-plans/admin/{id}';

  /**
   * 배치도 상세 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `floorPlanAdminControllerFindByIdV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  floorPlanAdminControllerFindByIdV1$Response(params: FloorPlanAdminControllerFindByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<FloorPlanDto>> {
    const obs = floorPlanAdminControllerFindByIdV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 배치도 상세 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `floorPlanAdminControllerFindByIdV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  floorPlanAdminControllerFindByIdV1(params: FloorPlanAdminControllerFindByIdV1$Params, context?: HttpContext): Observable<FloorPlanDto> {
    const resp = this.floorPlanAdminControllerFindByIdV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<FloorPlanDto>): FloorPlanDto => r.body)
    );
  }

  /** Path part for operation `floorPlanAdminControllerDeleteV1()` */
  static readonly FloorPlanAdminControllerDeleteV1Path = '/api/v1/floor-plans/admin/{id}';

  /**
   * 배치도 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `floorPlanAdminControllerDeleteV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  floorPlanAdminControllerDeleteV1$Response(params: FloorPlanAdminControllerDeleteV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = floorPlanAdminControllerDeleteV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 배치도 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `floorPlanAdminControllerDeleteV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  floorPlanAdminControllerDeleteV1(params: FloorPlanAdminControllerDeleteV1$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.floorPlanAdminControllerDeleteV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `floorPlanAdminControllerUpdateV1()` */
  static readonly FloorPlanAdminControllerUpdateV1Path = '/api/v1/floor-plans/admin/{id}';

  /**
   * 배치도 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `floorPlanAdminControllerUpdateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  floorPlanAdminControllerUpdateV1$Response(params: FloorPlanAdminControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<FloorPlanDto>> {
    const obs = floorPlanAdminControllerUpdateV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 배치도 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `floorPlanAdminControllerUpdateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  floorPlanAdminControllerUpdateV1(params: FloorPlanAdminControllerUpdateV1$Params, context?: HttpContext): Observable<FloorPlanDto> {
    const resp = this.floorPlanAdminControllerUpdateV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<FloorPlanDto>): FloorPlanDto => r.body)
    );
  }

  /** Path part for operation `floorPlanAdminControllerCreateBoothV1()` */
  static readonly FloorPlanAdminControllerCreateBoothV1Path = '/api/v1/floor-plans/admin/booth';

  /**
   * 부스 생성.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `floorPlanAdminControllerCreateBoothV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  floorPlanAdminControllerCreateBoothV1$Response(params: FloorPlanAdminControllerCreateBoothV1$Params, context?: HttpContext): Observable<StrictHttpResponse<BoothDto>> {
    const obs = floorPlanAdminControllerCreateBoothV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 부스 생성.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `floorPlanAdminControllerCreateBoothV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  floorPlanAdminControllerCreateBoothV1(params: FloorPlanAdminControllerCreateBoothV1$Params, context?: HttpContext): Observable<BoothDto> {
    const resp = this.floorPlanAdminControllerCreateBoothV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BoothDto>): BoothDto => r.body)
    );
  }

  /** Path part for operation `floorPlanAdminControllerDeleteBoothV1()` */
  static readonly FloorPlanAdminControllerDeleteBoothV1Path = '/api/v1/floor-plans/admin/booth/{id}';

  /**
   * 부스 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `floorPlanAdminControllerDeleteBoothV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  floorPlanAdminControllerDeleteBoothV1$Response(params: FloorPlanAdminControllerDeleteBoothV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = floorPlanAdminControllerDeleteBoothV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 부스 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `floorPlanAdminControllerDeleteBoothV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  floorPlanAdminControllerDeleteBoothV1(params: FloorPlanAdminControllerDeleteBoothV1$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.floorPlanAdminControllerDeleteBoothV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `floorPlanAdminControllerUpdateBoothV1()` */
  static readonly FloorPlanAdminControllerUpdateBoothV1Path = '/api/v1/floor-plans/admin/booth/{id}';

  /**
   * 부스 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `floorPlanAdminControllerUpdateBoothV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  floorPlanAdminControllerUpdateBoothV1$Response(params: FloorPlanAdminControllerUpdateBoothV1$Params, context?: HttpContext): Observable<StrictHttpResponse<BoothDto>> {
    const obs = floorPlanAdminControllerUpdateBoothV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 부스 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `floorPlanAdminControllerUpdateBoothV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  floorPlanAdminControllerUpdateBoothV1(params: FloorPlanAdminControllerUpdateBoothV1$Params, context?: HttpContext): Observable<BoothDto> {
    const resp = this.floorPlanAdminControllerUpdateBoothV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BoothDto>): BoothDto => r.body)
    );
  }

}
